import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FullLinkLang } from "./LinkLang";
import jQuery from "jquery";
import { subscribeToMobileImageInteraction } from "../utils/mobileImageDeferral";
import { sanitizeHtml } from "../utils/sanitize";
const $ = jQuery
function ReassuranceSection({ items, reserveSpace = false }) {
const sliderRef = useRef(null);

useEffect(() => {
  let disposed = false;
  let initializing = false;

  const initSlider = async () => {
    const sliderElement = sliderRef.current;
    if (!sliderElement || !items?.length) return;

    const $slider = $(sliderElement);
    const isDesktop = window.matchMedia("(min-width: 992px)").matches;
    const isPhone = window.matchMedia("(max-width: 767px)").matches;

    if (isDesktop) {
      if ($.fn.slick && $slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
      return;
    }

    if ($.fn.slick && $slider.hasClass("slick-initialized")) {
      $slider.slick(
        "slickSetOption",
        "slidesToShow",
        isPhone ? 1 : 2,
        true
      );
      return;
    }

    if (initializing) return;
    initializing = true;

    try {
      if (!$.fn.slick) {
        await import("slick-carousel");
      }

      if (
        !disposed &&
        sliderRef.current === sliderElement &&
        !isDesktop &&
        !$slider.hasClass("slick-initialized")
      ) {
        $slider.slick({
          arrows: false,
          dots: false,
          autoplay: true,
          speed: 1000,
          adaptiveHeight: false,
          slidesToShow: isPhone ? 1 : 2,
        });
      }
    } finally {
      initializing = false;
    }
  };
  
  const isDesktop = window.matchMedia("(min-width: 992px)").matches;
  const unsubscribeInteraction = isDesktop
    ? (() => {
        void initSlider();
        return () => {};
      })()
    : subscribeToMobileImageInteraction(() => void initSlider());
  
  // Re-initialize on resize
  window.addEventListener("resize", initSlider);
  
  return () => {
    disposed = true;
    unsubscribeInteraction();
    window.removeEventListener("resize", initSlider);
    const sliderElement = sliderRef.current;
    if (sliderElement && $.fn.slick) {
      const $slider = $(sliderElement);
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
    }
  };
}, [items]);
  if (!items?.length) {
    return reserveSpace ? (
      <section
        className="content-section reassurance-slot-placeholder"
        aria-hidden="true"
      />
    ) : null;
  }

  return (
    <section className="content-section">
      <div className="container">
        <div className="row sliderxs" ref={sliderRef}
          style={{
            marginBlock: "20px",
          }}
        >
          {items.map((item,index) => {
            const hasLink =
              item.redirection_type === "url" && FullLinkLang(item.redirection_url);

            const Wrapper = hasLink ? "a" : "div";
           
            return (
              <div key={item.id} className="col-md-4">
              <div className="reassurance-wrap h-100">
              <Wrapper
                key={item.id_reassurance_block || item.id}
                href={hasLink ? item.redirection_url : undefined}
                title={item.redirection_text || ""}
              >
                {/* ICON / IMAGE */}
                <div
                  style={{
                    flexShrink: 0,
                    width: "48px",
                    height: "48px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {item.image ? (
                    <img
                      src={item.image}
                      alt=""
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    item.icon_svg && (
                      <span
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.icon_svg) }}
                      />
                    )
                  )}
                </div>

                {/* DIVIDER */}
                <div
                  style={{
                    width: "1px",
                    height: "50px",
                    backgroundColor: "#dbdbdb",
                    margin: "0 20px",
                  }}
                />

                {/* TEXT */}
                <div style={{ flexGrow: 1 }}>
                  <h3
                    style={{
                      margin: "0 0 5px",
                      color: "#4a4a4a",
                      fontSize: "1.3rem",
                      fontFamily: "'Merriweather', Georgia, serif",
                    }}
                  >
                    {item.title}
                  </h3>

                  <p
                    style={{
                      margin: 0,
                      color: "#595959",
                      fontSize: "0.9rem",
                      lineHeight: 1.4,
                    }}
                  >
                    {item.description?.replace(/<[^>]*>/g, "")}
                  </p>
                </div>
              </Wrapper>
              </div>
              </div>

            );
          })}
        </div>
        
      </div>
    </section>
  );
}

export default ReassuranceSection;
